import { gql } from 'graphql-request'

export const GetLotDetailsGql = gql`
  query listLotDetails(
    $stationRecordNumber: String!
    $saleAndSeason: String
    $season: String
    $result: WoolSoldStatus
    $breed: Breed
    $stockAge: StockAge
  ) {
    listLotDetails(
      request: {
        stationRecordNumber: $stationRecordNumber
        saleAndSeason: $saleAndSeason
        season: $season
        result: $result
        breed: $breed
        stock: $stockAge
      }
    ) {
      results {
        referenceNumber
        bales
        coreTestColourYZ
        coreTestMicron
        coreTestMicronAirflow
        coreTestMicronLaserscan
        coreTestMicronOfda
        coreTestPointOfBreakBase
        coreTestPointOfBreakMid
        coreTestPointOfBreakTip
        coreTestStapleAverageStrength
        coreTestStapleLengthGreasy
        coreTestStapleStrength
        coreTestVegetableMatterBase
        coreTestYield
        description
        grossProceeds
        lineNumber
        lottedDate
        netKgs
        priceClean
        priceGreasy
        result
        season
        saleAndSeason
      }
      lotDetailTotals {
        bales
        grossProceeds
        netKgs
      }
      lotDetailWeightedAverages {
        coreTestColourYZ
        coreTestMicron
        coreTestMicronAirflow
        coreTestMicronLaserscan
        coreTestMicronOfda
        coreTestPointOfBreakBase
        coreTestPointOfBreakMid
        coreTestPointOfBreakTip
        coreTestStapleAverageStrength
        coreTestStapleLengthGreasy
        coreTestStapleStrength
        coreTestVegetableMatterBase
        coreTestYield
        priceClean
        priceGreasy
      }
    }
  }
`
